import ActionTypes from "../../../../constants/ActionTypes";
import { ICampaignListState } from "./types";
const initialState: ICampaignListState = {
  offers: {
    webos: {
      soft: [],
      ore: []
    },
    channel01: {
      soft: [],
      ore: []
    },
    currentTp: undefined,
    actualSubscription: 0
  }
};

const campaignListReducer = (
  state = initialState,
  action: any,
): any => {
  switch (action.type) {
  case ActionTypes.CAMPAIGN.LIST.SET_WEBOS_SOFT:
    return {
      ...state,
      offers: {
        ...state.offers,
        webos: {
          ...state.offers.webos,
          soft: action.payload
        }
      }
    };
  case ActionTypes.CAMPAIGN.LIST.SET_CHANNEL01_SOFT:
    return {
      ...state,
      offers: {
        ...state.offers,
        channel01: {
          ...state.offers.channel01,
          soft: action.payload
        }
      }
    };
  case ActionTypes.CAMPAIGN.LIST.SET_WEBOS_ORE:
    return {
      ...state,
      offers: {
        ...state.offers,
        webos: {
          ...state.offers.webos,
          ore: action.payload
        }
      }
    };
  case ActionTypes.CAMPAIGN.LIST.SET_CHANNEL01_ORE:
    return {
      ...state,
      offers: {
        ...state.offers,
        channel01: {
          ...state.offers.channel01,
          ore: action.payload
        }
      }
    };
  case ActionTypes.CAMPAIGN.LIST.SET_CURRENT_TP:
    return {
      ...state,
      currentTp: action.payload.tp,
      actualSubscription: action.payload.actualSubscription
    };
  }
  return state;
};

export default campaignListReducer;

